import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export default function Notifications() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/notifications").then((r)=>setRows(r.data)); }, []);

  return (
    <div className="space-y-8 max-w-3xl">
      <div>
        <div className="accp-label">Alerts</div>
        <h1 className="text-4xl font-semibold text-primary" style={{fontFamily:'Outfit'}}>Notifications</h1>
        <p className="text-muted-foreground mt-1">Certification expiry · Missed clock-ins · Overtime.</p>
      </div>
      {rows.length === 0 ? (
        <div className="accp-card p-8 text-center text-muted-foreground">
          <Bell size={32} className="mx-auto mb-2 opacity-60"/>
          All clear — no active alerts.
        </div>
      ) : (
        <ul className="space-y-3">
          {rows.map((a) => (
            <li key={a.id} className={`accp-card p-5 ${a.severity==="high"?"border-l-4 border-l-[#B71C1C]":"border-l-4 border-l-[#E2B400]"}`}
                data-testid={`notif-${a.type}`}>
              <div className="flex justify-between items-start gap-3">
                <div>
                  <div className="accp-label">{a.type.replace("_"," ")}</div>
                  <h3 className="font-semibold text-primary mt-1" style={{fontFamily:'Outfit'}}>{a.title}</h3>
                  <p className="text-sm text-muted-foreground mt-1">{a.message}</p>
                </div>
                <span className={`shrink-0 inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${
                  a.severity==="high" ? "compliance-expired" : "bg-[#FFF8E6] text-[#7A5A00] border border-[#FFE4A0]"
                }`}>{a.severity}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
